import { ProjectItem } from '../types';

export const portfolioData: ProjectItem[] = [
  {
    id: 'web-platforms',
    title: 'Enterprise Web & AI Platforms',
    category: 'Web Platforms',
    summary: 'Cloud-native intelligent web application with real-time analytics, modular micro-frontends, and automated client onboarding.',
    fullDetails: 'A high-performance web platform engineered for modern enterprise scale. Features sub-second page transitions, dynamic content generation, interactive telemetry dashboards, and multi-region edge deployment.',
    image: '/assets/portfolio-web-hd.jpg',
    tags: ['React', 'TypeScript', 'Node.js', 'Tailwind CSS', 'AWS Edge'],
    clientType: 'Enterprise B2B SaaS',
    deliverables: ['Custom Web Architecture', 'UI/UX Design System', 'API Gateway', 'Automated CI/CD'],
    results: ['68% increase in visitor engagement', '0.6s average global load time', '99.98% operational uptime']
  },
  {
    id: 'mobile-experiences',
    title: 'Cross-Platform Mobile Experiences',
    category: 'Mobile Experiences',
    summary: 'Sleek, fluid cross-platform mobile application supporting instant biometrics, offline sync, and real-time push events.',
    fullDetails: 'Crafted for seamless mobile workflows, this application delivers high frame rate performance, instant background synchronization, intuitive gesture navigation, and native operating system integration on both iOS and Android.',
    image: '/assets/portfolio-mobile-hd.jpg',
    tags: ['React Native', 'TypeScript', 'GraphQL', 'Firebase', 'iOS & Android'],
    clientType: 'Digital Fintech / Commerce',
    deliverables: ['Cross-Platform Mobile App', 'Design Tokens & UI Kit', 'Push Notification Pipeline', 'App Store Submission'],
    results: ['4.9-star average app store rating', '120k+ monthly active sessions', '35% reduction in cart drop-off']
  },
  {
    id: 'business-software',
    title: 'Modern Business & ERP Software',
    category: 'Business Software',
    summary: 'Integrated operational ERP suite connecting supply chain logistics, multi-location inventory, and executive revenue reporting.',
    fullDetails: 'An enterprise management suite designed to replace brittle manual spreadsheets with unified real-time visibility. Features modular billing, vendor management, automated ledger reconciliations, and role-based access control.',
    image: '/assets/portfolio-business-hd.jpg',
    tags: ['Next.js', 'PostgreSQL', 'Docker', 'RESTful APIs', 'Tailwind UI'],
    clientType: 'Logistics & Supply Chain Group',
    deliverables: ['Custom ERP System', 'Data Migration Pipeline', 'Automated Billing Engine', 'Staff Training Modules'],
    results: ['42% reduction in order processing time', 'Zero inventory reconciliation errors', '$180k annual licensing savings']
  },
  {
    id: 'ai-automation-suite',
    title: 'Intelligent AI Automation Suite',
    category: 'AI & Automation',
    summary: 'Autonomous document parsing, predictive customer behavior modeling, and 24/7 intelligent conversational agents.',
    fullDetails: 'Engineered for high-volume enterprise operations, this AI solution utilizes custom fine-tuned LLMs and vector databases to automate multi-language customer inquiries and unstructured data ingestion.',
    image: '/assets/portfolio-ai-hd.jpg?v=2',
    tags: ['Python', 'FastAPI', 'OpenAI API', 'Pinecone', 'React Dashboard'],
    clientType: 'Healthcare & Technology Services',
    deliverables: ['AI Knowledge Engine', 'Telemetry Dashboard', 'Security Compliance Audit', 'Real-time Webhook Orchestrator'],
    results: ['80% reduction in first-response latency', 'Over 1.2M queries handled autonomously', 'SOC2-compliant audit grade']
  },
  {
    id: 'ecommerce-retail',
    title: 'High-Conversion Omnichannel E-Commerce',
    category: 'E-Commerce',
    summary: 'Ultra-fast global storefront with multi-currency pricing, headless Shopify/WooCommerce architecture, and frictionless 1-click checkout.',
    fullDetails: 'Engineered to maximize conversions and average order value across North America and Europe. Integrates real-time inventory synchronisation across physical and digital sales channels, automated abandoned cart recovery, and sub-second catalog search.',
    image: '/assets/portfolio-ecommerce-hd.jpg?v=2',
    tags: ['Next.js', 'Headless Commerce', 'Stripe Global', 'Tailwind CSS', 'Algolia Search'],
    clientType: 'International Retail & D2C Brands',
    deliverables: ['Headless Storefront', 'Payment Gateway Integration', 'Dynamic Filter Engine', 'Conversion Rate Optimization'],
    results: ['+48% increase in mobile conversion', '2.1s faster checkout completion', 'Zero downtime during holiday traffic surges']
  },
  {
    id: 'digital-marketing-seo',
    title: 'Keyword SEO & Performance Growth Engine',
    category: 'Digital Marketing',
    summary: 'Data-driven Google Ads management and technical international SEO generating consistent high-intent client inquiries.',
    fullDetails: 'A full-funnel digital marketing engine matching keyword intent with high-converting landing pages. Combines programmatic SEO, local & international search visibility, automated Google Ads bid strategy, and transparent ROI reporting.',
    image: '/assets/portfolio-marketing-hd.jpg',
    tags: ['Technical SEO', 'Google Ads', 'GA4 Analytics', 'Schema Markup', 'Landing Page CRO'],
    clientType: 'B2B Services & E-Commerce',
    deliverables: ['International SEO Audit', 'High-Intent Keyword Map', 'PPC Campaign Management', 'Weekly Executive Analytics'],
    results: ['3.4x average ROAS on paid search', '+140% organic organic search reach', 'Top 3 rankings for 45+ commercial keywords']
  }
];
